import { PatientPharmacy, PharmacyQueryType } from "~/common/types/pharmacies";
import { api, PaginatedServiceResponse } from "./axios";

const pharmaciesPath = (patientId: string) =>
  `/v1/team-members/patients/${patientId}/pharmacies`;

const pharmaciesListParams = {
  page_size: 100,
  page: 1,
  order_by: "created_at",
};

export const getTeamMemberPatientPharmacies = async (patientId: string) => {
  const { data } = await api.get<PaginatedServiceResponse<PharmacyQueryType[]>>(
    pharmaciesPath(patientId),
    {
      params: pharmaciesListParams,
    },
  );

  return data.data;
};

export const deleteTeamMemberPatientPharmacy = async (
  patientId: string,
  pharmacyId: string,
) => {
  const { data } = await api.delete<void>(
    `${pharmaciesPath(patientId)}/${pharmacyId}`,
  );

  return { data };
};

export const createTeamMemberPatientPharmacy = async (
  patientId: string,
  pharmacy: PatientPharmacy,
) => {
  const { data } = await api.post<PharmacyQueryType>(
    pharmaciesPath(patientId),
    pharmacy,
  );

  return { data };
};

export const updateTeamMemberPatientPharmacy = async (
  patientId: string,
  pharmacy: PatientPharmacy,
  pharmacyId: string,
) => {
  const { data } = await api.put<void>(
    `${pharmaciesPath(patientId)}/${pharmacyId}`,
    pharmacy,
  );

  return { data };
};

export const setDefaultTeamMemberPatientPharmacy = async (
  patientId: string,
  pharmacyId: string,
) => {
  const { data } = await api.post<void>(
    `${pharmaciesPath(patientId)}/${pharmacyId}/set-default`,
    {},
  );

  return { data };
};
